/**
 * @fileoverview Agent definition for world-place-ideation-v3.
 *
 * This agent generates ideas for significant places (locations, buildings)
 * that could appear in the story world.
 *
 * @category world-building.places.creation
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'world-place-ideation-v3',
  kind: 'primitive',
  name: 'World Place Ideation',
  description: 'Generates ideas for significant places (locations, buildings) in your story world.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    taxonomyPath: 'world-building.places.creation',
    usedBy: [
      'use-world-place-ideation-v3.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'world-place-details-ideation-v3',
      'world-place-details-generator-v3',
    ],
  },
};
